"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var semantic_ui_react_1 = require("semantic-ui-react");
var placeholder_png_1 = __importDefault(require("../../../../staticAssets/images/placeholder.png"));
var LazyBackground = /** @class */ (function (_super) {
    __extends(LazyBackground, _super);
    function LazyBackground() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { src: null };
        return _this;
    }
    LazyBackground.prototype.componentDidMount = function () {
        var _this = this;
        var src = this.props.src;
        var imageLoader = new Image();
        imageLoader.src = src;
        imageLoader.onerror = function () {
            // Decide what to do on error
            _this.setState({ src: placeholder_png_1.default });
        };
        imageLoader.onload = function () {
            _this.setState({ src: src });
        };
    };
    LazyBackground.prototype.render = function () {
        var src = this.state.src;
        return (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { className: "content-img", width: 6, style: { backgroundImage: "url(".concat(src ? src : placeholder_png_1.default, ")"), height: "100%" }, as: react_router_dom_1.Link, to: "../../".concat(this.props.url, "/") });
    };
    return LazyBackground;
}(react_1.default.Component));
exports.default = LazyBackground;
